"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); if (r) { o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; }); } t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    input: {
      width: "100%",
      backgroundColor: theme.palette.common.white,
      borderRadius: ".5rem"
    },
    inputDisabled: {
      width: "100%",
      backgroundColor: theme.palette.grey[100],
      borderRadius: ".5rem"
    },
    errorText: {
      marginTop: ".5rem",
      marginLeft: "1rem",
      color: theme.palette.error.dark,
      fontWeight: "bold"
    }
  };
});
var Input = function Input(_ref, _ref2) {
  var testId = _ref.testId,
    disabled = _ref.disabled,
    value = _ref.value,
    label = _ref.label,
    onChange = _ref.onChange,
    error = _ref.error,
    errorText = _ref.errorText;
  var rest = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, _objectSpread({
      "data-test-id": testId,
      className: classes.input,
      label: label,
      disabled: disabled,
      InputLabelProps: {
        shrink: true
      },
      variant: "outlined",
      autoComplete: "off",
      value: value,
      onChange: onChange,
      error: error
    }, rest)), error && errorText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.errorText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "h5",
        children: errorText
      })
    })]
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Input);